import { createModel, RematchDispatch } from '@rematch/core';
import { PaginationType } from 'types/common.d';
import { PermissionType } from 'types/entities/permissions.d';
import * as api from 'services/permissions';
import { RootModel } from '../models';
import baseEntity from './base.entity';

export const storeName = 'permissionsEntity';

export const permissionsEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof permissionsEntity>) => ({
    async load(payload): Promise<{ content: PermissionType[] } & PaginationType> {
      try {
        const res = await api.filter(payload);
        const { content } = res.data;
        if (content && content.length) {
          this.saveSimplified(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default permissionsEntity;
